import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { ApiConfig } from "@/config/api.config";
import { ApiHookProps } from '@/@types/api.types';
import { OwnerListResponseDto } from '@/features/owners/types/owners-dto';
import { UrlHelper } from '@/utils/UrlHelper';
import { useOwnersFilter } from './useOwnersFilter';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';

type Props = {
    search?: string;
} & ApiHookProps;

export const useOwnersListApi = ({searchText}: Props = {}) => {
    const axiosInstance = useAxiosAuth();
    const { filter } = useOwnersFilter();
    const { take, skip, apartmentId, ownerId, ownerStatus, orderBy, orderDirection } = filter;

    const apartmentIds = apartmentId?.map((apartment) => apartment.id);
    const ownerIds = ownerId?.map((owner) => owner.id);

    const {
        data: ownersListData, 
        isLoading: isLoadingOwnersListData, 
        isError: isErrorOwnersListData
    } = useQuery({
        queryKey: [
            ApiConfig.queries.features.owners.queryKeys.list, 
            searchText, take, skip, apartmentId, ownerId, ownerStatus, orderBy, orderDirection
        ],
        queryFn: async (): Promise<OwnerListResponseDto> => {
            const url = UrlHelper.buildUrlWithQueryParams(ApiConfig.queries.features.owners.endpoints.list, {
                searchText, take, skip, apartmentId: apartmentIds, ownerId: ownerIds, ownerStatus, orderBy, orderDirection
            });
            const response = await axiosInstance.get<OwnerListResponseDto>(url);
            return response.data;
        },
        placeholderData: keepPreviousData
    });

    return {
        ownersListData,
        isLoadingOwnersListData,
        isErrorOwnersListData,   
    }
}